export default __webpack_public_path__ + "static/media/Champagne_&_Limousines_Bold.6f3cd024.ttf";